import React from 'react';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import './Inputs.css'

// The value is in in E.164 format e.g. "+12345678900".
type Props = {
  label: string;
  value: string | null | undefined
  error: string | null | undefined
  onChange: (value: string) => void;
}

export const SurveyPhoneInput = (props: Props) => {

  return <div className={'SurveyPhoneInput'}>
    <PhoneInput
        placeholder="Enter phone number"
        defaultCountry={'US'}
        value={props.value || ''}
        onChange={v => props.onChange(v as string)}/>
  </div>

}